import './ActionFieldButton.style.less'

interface Prop {
  className: string
  label: string
  onClicked: (actualDate: any) => any
}

function ActionFieldButton(prop: Prop) {
  const { className, onClicked, label } = prop

  return (
    <>
      <div className="action-button-container">
        <div className="ant-space ant-space-horizontal ant-space-align-center">
          <div className="ant-space-item">
            <button
              type="button"
              className={`ant-btn ant-btn-round ${className}`}
              onClick={onClicked}
            >
              <span>{label}</span>
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default ActionFieldButton
